module.exports = require("./zu-ZA");